module.exports = __webpack_public_path__ + "static/media/ssg.56e8ddf9.jpg";